import React, { useState } from "react";
import { Link } from "react-router-dom"; // ✅ Import Link for routing

function AppNavbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-gray-100 shadow py-3">
      <div className="container mx-auto px-4 flex items-center justify-between flex-wrap">
        {/* Brand/Logo */}
        <Link to="/" className="flex items-center flex-shrink-0 mr-6">
          <img
            src="https://picsum.photos/100/50"
            height="30"
            className="inline-block align-top h-8"
            alt="Logo"
          />
        </Link>

        {/* Mobile Toggle Button */}
        <div className="block lg:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center px-3 py-2 border rounded text-gray-500 border-gray-400 hover:text-gray-700 hover:border-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-customcolor"
            aria-label="Toggle navigation"
            aria-expanded={isOpen ? "true" : "false"}
          >
            <svg
              className="fill-current h-3 w-3"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-1z" />
            </svg>
          </button>
        </div>

        {/* Collapsible Menu */}
        <div
          className={`${
            isOpen ? "block" : "hidden"
          } w-full flex-grow lg:flex lg:items-center lg:w-auto`}
        >
          <div className="text-sm lg:flex-grow lg:flex lg:justify-end lg:pr-5">
            {/* ✅ Updated navigation routes */}
            <Link
              to="/"
              className="nav-a block mt-4 lg:inline-block lg:mt-0 text-gray-700 hover:text-customcolor mr-4 py-2 px-3 lg:px-0 lg:py-0 transition duration-300"
            >
              Home
            </Link>
            <Link
              to="/how-it-works"
              className="nav-a block mt-4 lg:inline-block lg:mt-0 text-gray-700 hover:text-customcolor mr-4 py-2 px-3 lg:px-0 lg:py-0 transition duration-300"
            >
              Features
            </Link>
            <Link
              to="/about"
              className="nav-a block mt-4 lg:inline-block lg:mt-0 text-gray-700 hover:text-customcolor mr-4 py-2 px-3 lg:px-0 lg:py-0 transition duration-300"
            >
              About
            </Link>
            <Link
              to="/schedule-demo"
              className="nav-a block mt-4 lg:inline-block lg:mt-0 text-gray-700 hover:text-customcolor py-2 px-3 lg:px-0 lg:py-0 transition duration-300"
            >
              Contact
            </Link>
          </div>

          {/* Action Buttons */}
          <div className="mt-4 lg:mt-0">
            <button className="inline-block text-sm px-4 py-2 leading-none border rounded text-customcolor border-customcolor hover:border-transparent hover:text-white hover:bg-customcolor mt-4 lg:mt-0 mr-2 transition duration-300">
              Sign In
            </button>
            <button className="inline-block text-sm px-4 py-2 leading-none bg-customcolor text-white rounded hover:bg-customcolor mt-4 lg:mt-0 transition duration-300">
              Get Started
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default AppNavbar;
